module.exports = __webpack_public_path__ + "img/3-2.a6901d70.png";